<template>
    <!-- <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-11" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Search Filter</ion-title>
        <ion-buttons slot="end">
            <ion-button data-testid="directions-12" @click="reset">
                <span>Reset</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar> -->

    <div class="main_wrapper ion-padding">
        <!-- <div class="search-bar"><el-input v-model="selectedValues.text" class="job-board__search" placeholder="Search" clearable
                @clear="clearText">
                <template #prefix>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                            stroke="#484848" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M22 22L20 20" stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </template>
            </el-input>
            <button class="filter-button">
                <img src="@/assets/img/job-seeker/setting-active.svg" />
            </button>
        </div> -->
        
        <el-button class="reset-button" @click="reset">Reset</el-button>
        <div v-if="loading">
            <JobListingFilterSkeleton :skeletonCount="1" />
        </div>
        <div v-else>
            <div v-if="isFilterOptionsVisible" class="filter-options">
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Type</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(type, index) in types" :key="index">
                            <input data-testid="directions-14" type="radio" name="type" :id="'jobType-' + index"
                                v-model="selectedValues.type" :value="type.jobApplicantCategory">
                            <label :for="'jobType-' + index">{{ type.jobApplicantCategory }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <el-form-item class="button_submit mb0">
                <el-button class="submit" type="blue" data-testid="directions-17" @click="goSearch">
                    Apply
                </el-button>
            </el-form-item>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount,defineEmits } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import JobListingFilterSkeleton from "@/components/JobListingSkeleton/JobListingFilterSkeleton.vue";
const $store = useStore();
const $router = useRouter();
const isFilterOptionsVisible = ref(true);
const currentRouteName = ref(null);
const loading = ref(false);
const emit = defineEmits(['update:modalJobApplicationVisible']);
const selectedValues = ref({
    text: '',
    type: ''
});

const types = ref([]);

onBeforeMount(async () => {
    loading.value = true;
    const applicantStatusCategoriesResponse = await $store.dispatch("GET_JOB_APPLICANT_STATUS_CATEGORIES");
    loading.value = false;
    types.value = applicantStatusCategoriesResponse.data;
    types.value.push({ id: '--', jobApplicantCategory: 'Uncategorized' });
})

// Function to reset filters
const reset = () => {
    localStorage.removeItem('jobPosterApplicantsFilterObject');
    selectedValues.value = {
        text: '',
        type: '',
    };
}

// Function to navigate back
// const goBack = () => {
//     currentRouteName.value = $router.currentRoute.value.name;
//     console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
//     $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

//     $router.push({
//         name: "job_poster",
//     });
// };

// Function to perform search
const goSearch = () => {
    // Save selected values to local storage
    localStorage.setItem('jobPosterApplicantsFilterObject', JSON.stringify(selectedValues.value));

    // Perform search action
    currentRouteName.value = $router.currentRoute.value.name;
    console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
    $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);
    // $router.push({
    //     name: "job_poster",
    // });
    emit('update:modalJobApplicationVisible', false);
    emit("job-poster-application-filter");
};

// const clearText = () => {
//     console.log('clear text')
//     selectedValues.value.text = '';
//     // Update local storage to remove only the 'text' property from 'jobPosterApplicantsFilterObject'
//     const storedValues = JSON.parse(localStorage.getItem('jobPosterApplicantsFilterObject'));
//     if (storedValues) {
//         delete storedValues.text;
//         localStorage.setItem('jobPosterApplicantsFilterObject', JSON.stringify(storedValues));
//     }
// };

// Restore selected values from local storage on component mount
onMounted(() => {
    const storedValues = localStorage.getItem('jobPosterApplicantsFilterObject');
    if (storedValues) {
        selectedValues.value = JSON.parse(storedValues);
    }

});

</script>
